import { SyncMessage } from "../db/models/synchronizer";
import ConfirmModal from "../../core/modals/confirm/index";
import { BaseApp } from "../app";
import { ModalResultType } from "../modal/index";

export default class ViewActions
{
    private app: BaseApp;

    constructor(app: BaseApp)
    {
        this.app = app;
    }

    public confirmAndPush(confirmModal: ConfirmModal, message: SyncMessage, refreshView = true): PromiseLike<void>
    {
        return new Promise((resolve, reject) =>
        {
            this.app.modals.show(confirmModal).then(() =>
            {
                if (confirmModal.result.type === ModalResultType.YES)
                {
                    this.app.synchronizer.createMessageAndPull(message, refreshView).then(resolve);
                }
                else
                {
                    reject();
                }
            });
        })

    }
}